import { useEffect, useReducer, useState } from 'react';
import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from 'react-redux';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  fetchRestaurantDashboardReservationDetails,
  restaurantDashboardReservationTableSelector,
} from '../../DashboardSlice';
import MomentUtils from '@date-io/moment';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import {
  KeyboardTimePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import CustomCheckbox from '../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import { REST_GUEST_TYPE } from '../../../../constants/DashboardConst';
import {
  createRestaurantReservations,
  updateRestaurantReservations,
} from '../../../../utils/dashboardAPIUtils';
import moment from 'moment';
import { getRestaurantTiming } from '../../../../utils/dashboardUtils';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const DashboardReservationsCreate = (props) => {
  const {
    toggleDrawer,
    reservation,
    hotelId,
    restaurantId,
    selectedRestaurant,
    showLoader = () => {},
  } = props;
  const [custTables, setcustTables] = useState([]);
  const tables = useSelector(restaurantDashboardReservationTableSelector);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [guestReserve, setguestReserve] = useState(false);
  const [exposures, setExposures] = useState([]);

  useEffect(() => {
    if (tables?.length) {
      let tempExposures = [];
      tables.forEach((element) => {
        tempExposures.push({
          exposure: element.exposure,
        });
      });
      tempExposures = tempExposures.filter(
        (v, i, a) => a.findIndex((v2) => v2.exposure === v.exposure) === i,
      );
      setExposures(tempExposures);
    }
  }, [tables]);

  useEffect(() => {
    if (reservation) {
      const currFields = { ...formData };
      currFields.exposure.value = reservation.exposure;
      setTableList(reservation.exposure);
      currFields.tableNumbers.value = reservation.tableNumbers;
      currFields.date.value = reservation.date;
      currFields.reserveFrom.value = reservation.reserveFrom;
      currFields.reserveUntil.value = reservation.reserveUntil;
      currFields.description.value = reservation.description;
      currFields.isReservedForGuest.value = reservation.isReservedForGuest;
      currFields.firstName.value = reservation.firstName;
      currFields.lastName.value = reservation.lastName;
      currFields.roomNo.value = reservation.roomNo;
      currFields.guestType.value = reservation.guestType;
      setReserveGuest(currFields.guestType);
      currFields.noOfGuests.value = reservation.noOfGuests;
      setFormData(currFields);
    }
  }, [reservation]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    exposure: {
      value: '',
      fieldName: 'Exposure',
      errors: {},
      validations: ['required'],
    },
    tableNumbers: {
      value: [],
      fieldName: 'Table Number',
      errors: {},
      validations: ['required'],
    },
    date: {
      value: moment(new Date()).format('YYYY-MM-DD'),
      fieldName: 'Date',
      errors: {},
      validations: ['required'],
    },
    reserveFrom: {
      value: moment(new Date().setSeconds(new Date().getSeconds() + 60)).format('HH:mm'),
      fieldName: 'Reserve From',
      errors: {},
      validations: ['required', 'validTime'],
    },
    reserveUntil: {
      value: moment(new Date().setSeconds(new Date().getSeconds() + 60)).format('HH:mm'),
      fieldName: 'Reserve To',
      errors: {},
      validations: ['required', 'validTime'],
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 1000,
      tab: 0,
    },
    isReservedForGuest: {
      value: false,
      fieldName: 'Reserve for Guest',
      errors: {},
      validations: [],
    },
    guestType: {
      value: '',
      fieldName: 'Guest Type',
      errors: {},
      validations: [],
    },
    firstName: {
      value: '',
      fieldName: 'First Name',
      errors: {},
      validations: [],
    },
    lastName: {
      value: '',
      fieldName: 'Last Name',
      errors: {},
      validations: [],
    },
    noOfGuests: {
      value: 0,
      fieldName: 'Number of Guest(s)',
      errors: {},
      validations: [],
    },
    roomNo: {
      value: '',
      fieldName: 'Room Number',
      errors: {},
      validations: [],
    },
  });

  const validate = (isUpdatedFields) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedFields ? updatedFields : false);
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(true)) {
      setLoading(true);
      const payload = {};
      for (let field in formData) {
        payload[field] = formData[field].value;
      }
      try {
        dispatch(stepUpLoaderCount());
        const lang = decryptLocalStorage('lang');
        const language = lang !== 'en' ? lang : '';
        if (reservation) {
          payload.id = reservation.id;
          await updateRestaurantReservations(payload, hotelId, restaurantId, language);
          notificationManager('success', 'Reservation updated successfully');
        } else {
          await createRestaurantReservations(payload, hotelId, restaurantId, language);
          notificationManager('success', 'Reservation created successfully');
        }
        dispatch(fetchRestaurantDashboardReservationDetails(restaurantId, hotelId));
        setLoading(false);
        toggleDrawer('', false, '');
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          reservation
            ? notificationManager('danger', 'Reservation updation failed')
            : notificationManager('danger', 'Reservation creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
    }
  };

  const setTableList = (value) => {
    let tempTables = [];
    tables.forEach((element) => {
      if (element.exposure === value) {
        tempTables.push({ ...element });
      }
    });
    setcustTables(tempTables);
  };

  const updateTableList = (e) => {
    const currFields = { ...formData };
    currFields.exposure.value = e.value;
    currFields.tableNumbers.value = [];
    setFormData(currFields);
    setTableList(formData.exposure.value);
  };

  const handleDateTimePickerChange = (date, value, type) => {
    const currDateField = { ...formData[type] };
    currDateField.value = value;
    handleValidation(currDateField);
    setFormData({
      [type]: currDateField,
    });
  };

  const setReserveGuest = (e) => {
    setguestReserve(e.value);
    const currFields = { ...formData };
    currFields.isReservedForGuest = e;
    if (e.value) {
      currFields.guestType.validations = ['required'];
      currFields.firstName.validations = ['required'];
      currFields.lastName.validations = ['required'];
      currFields.noOfGuests.validations = ['required'];
    } else {
      currFields.guestType.value = '';
      currFields.firstName.value = '';
      currFields.lastName.value = '';
      currFields.noOfGuests.value = 0;
      currFields.guestType.validations = [];
      currFields.firstName.validations = [];
      currFields.lastName.validations = [];
      currFields.noOfGuests.validations = [];
      currFields.roomNo.validations = [];
    }
    setFormData(currFields);
  };

  const setGuestType = (e) => {
    const currFields = { ...formData };
    currFields.guestType = e;
    if (e.value === 'resident') {
      currFields.roomNo.validations = ['required'];
    } else {
      currFields.roomNo.value = '';
      currFields.roomNo.validations = [];
    }
    setFormData(currFields);
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (type === 'reserveFrom' || type === 'reserveUntil' || type === 'date') {
      if (formData[type].errors.validDate) return formData[type].errors.validDate;
    } else {
      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  const isAddUpdateButtonDisabled = () => {
    if (loading) return true;
    return (
      !validate(false) ||
      rendarErrorMessage('dateType') ||
      (guestReserve && rendarErrorMessage('tableCapacity'))
    );
  };

  const isValidDateTime = () => {
    const selectedDate = { ...formData.date };
    const reserveFrom = { ...formData.reserveFrom };
    const reserveUntil = { ...formData.reserveUntil };
    var fromDate = new Date(selectedDate.value);
    fromDate.setHours(reserveFrom.value?.split(':')[0]);
    fromDate.setMinutes(reserveFrom.value?.split(':')[1]);

    var toDate = new Date(selectedDate.value);
    toDate.setHours(reserveUntil.value?.split(':')[0]);
    toDate.setMinutes(reserveUntil.value?.split(':')[1]);
    const today = new Date();
    if (fromDate.getTime() <= today.getTime()) return false;
    if (toDate.getTime() < fromDate.getTime()) return false;
    else return true;
  };

  const isTableBooked = () => {
    const selectedDate = { ...formData.date };
    const reserveFrom = { ...formData.reserveFrom };
    const reserveUntil = { ...formData.reserveUntil };
    const tableSelected = { ...formData.tableNumbers };
    let isBooked = false;
    return custTables?.some((tables) => {
      tableSelected.value.forEach((table) => {
        if (table === tables.tableNumber) {
          if (!isBooked && tables.reservations != null) {
            tables.reservations.some((data) => {
              const reservationData = data.split('#');
              if (reservationData[1] === 'DATE' && reservationData[2] === selectedDate.value) {
                isBooked = checkIfBooked(reservationData[4], reserveFrom, reserveUntil);
              } else if (
                reservationData[3] === 'DATE' &&
                reservationData[4] === selectedDate.value
              ) {
                isBooked = checkIfBooked(
                  reservationData[6],
                  reserveFrom,
                  reserveUntil,
                  reservationData[2],
                );
              }
              if (isBooked) {
                return true;
              }
            });
          }
        }
      });
      return isBooked;
    });
  };

  const checkIfBooked = (time, reserveFrom, reserveUntil, id) => {
    const getBothTime = time;
    const startTime = moment(getBothTime.split('-')[0], 'HH:mm');
    const endTime = moment(getBothTime.split('-')[1], 'HH:mm');
    const isStartBetween = moment(reserveFrom.value, 'HH:mm').isBetween(startTime, endTime);
    const isEndBetween = moment(reserveUntil.value, 'HH:mm').isBetween(startTime, endTime);
    const isSame = moment(reserveFrom.value, 'HH:mm').isSame(startTime);
    if (
      (isStartBetween || isEndBetween || isSame) &&
      (!reservation || (reservation && id !== reservation.id))
    ) {
      return true;
    }
    return false;
  };

  const isRestaurantOpen = () => {
    const currDate = { ...formData.date };
    const currRestaurantTime = getRestaurantTiming(currDate.value, selectedRestaurant);
    if (currRestaurantTime.length === 0) return false;
    return true;
  };

  const rendarErrorMessage = (type) => {
    if (type === 'dateType') {
      if (!isRestaurantOpen()) return `We are close on this day`;
      if (!isValidDateTime()) return `Selected Date/Time is not valid`;
      if (isTableBooked()) return `Selected table is not available for the selected Date/Time`;
      return '';
    }
    if (type === 'tableCapacity') {
      if (Number(formData.noOfGuests.value) === 0) return `Please add atleast 1 person`;
      let capacity = 0;
      const tableCapacity = formData.tableNumbers.value.some((currtableNumbers) => {
        const currTables = custTables.find((tables) => tables.tableNumber === currtableNumbers);
        capacity = capacity + (currTables && currTables.capacity ? currTables.capacity : 0);
        return capacity >= formData.noOfGuests.value;
      });
      if (!tableCapacity)
        return `No of guest is exceeding the capacity for the selected table. Please add an additional table`;
      return '';
    }
  };

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-11'>
            <span className='page-title'>
              {reservation ? 'Edit Reservation' : 'Add Reservation'}
            </span>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                item={formData.exposure}
                handleInputChange={(e) => {
                  updateTableList(e);
                }}
                labelField='exposure'
                valueField='exposure'
                options={exposures}
                hideNullOption={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomMultiSelect
                item={formData.tableNumbers}
                handleInputChange={(e) => {
                  setFormData({ tableNumbers: e });
                }}
                selectAllOption={true}
                selectAllText='All tables in this Exposure'
                labelField='tableNumber'
                valueField='tableNumber'
                isSearchable={true}
                options={custTables}
                hideNullOption={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  variant='inline'
                  margin='normal'
                  id='Date'
                  label='Date'
                  className='col-md-12 mb-2'
                  format='yyyy-MM-DD'
                  required={formData.date.validations.includes('required')}
                  inputValue={formData.date.value}
                  onChange={(date, value) => handleDateTimePickerChange(date, value, 'date')}
                  error={
                    formData.date?.errors.required || formData.date?.errors.validDate ? true : false
                  }
                  helperText={setErrorText('date')}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className='col-md-6 mb-3 d-flex justify-content-center'>
              <p className='input-error align-self-end'>{rendarErrorMessage('dateType')}</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id='reserveFrom'
                  label='Reserve From'
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={formData.reserveFrom.validations.includes('required')}
                  inputValue={formData.reserveFrom.value}
                  onChange={(date, value) => handleDateTimePickerChange(date, value, 'reserveFrom')}
                  error={
                    formData.reserveFrom?.errors.required || formData.reserveFrom?.errors.validTime
                      ? true
                      : false
                  }
                  helperText={setErrorText('reserveFrom')}
                  keyboardIcon={<WatchLaterIcon />}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className='col-md-6 mb-3'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id='reserveUntil'
                  label='Reserve To'
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={formData.reserveUntil.validations.includes('required')}
                  inputValue={formData.reserveUntil.value}
                  onChange={(date, value) =>
                    handleDateTimePickerChange(date, value, 'reserveUntil')
                  }
                  error={
                    formData.reserveUntil?.errors.required ||
                    formData.reserveUntil?.errors.validTime
                      ? true
                      : false
                  }
                  helperText={setErrorText('reserveUntil')}
                  keyboardIcon={<WatchLaterIcon />}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          <div className='row'></div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                maxLength='1000'
                multiline={true}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomCheckbox
                item={formData.isReservedForGuest}
                handleInputChange={(e) => {
                  setReserveGuest(e);
                }}
                color='primary'
              />
            </div>
          </div>
          {guestReserve && (
            <>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.guestType}
                    handleInputChange={(e) => {
                      setGuestType(e);
                    }}
                    labelField='name'
                    valueField='id'
                    options={REST_GUEST_TYPE}
                    hideNullOption={true}
                  />
                </div>
                {formData.guestType.value === 'resident' && (
                  <>
                    <div className='col-md-6 mb-3'>
                      <CustomTextField
                        item={formData.roomNo}
                        handleInputChange={(e) => {
                          setFormData({ roomNo: e });
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.firstName}
                    handleInputChange={(e) => {
                      setFormData({ firstName: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.lastName}
                    handleInputChange={(e) => {
                      setFormData({ lastName: e });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    type='number'
                    item={formData.noOfGuests}
                    handleInputChange={(e) => {
                      setFormData({ noOfGuests: e });
                    }}
                  />
                </div>
                <div className='col-md-6 mb-3 d-flex justify-content-center'>
                  <p className='input-error align-self-end'>
                    {rendarErrorMessage('tableCapacity')}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              disabled={isAddUpdateButtonDisabled()}
              onClick={handleSubmit}
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
            >
              {reservation ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='default'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DashboardReservationsCreate;
